import { useAuthStore } from '../../stores/authStore';
import { useTaskProcessingStore } from '../../stores/taskProcessing.store';

const TASK_PROCESSING_STORAGE_KEY = 'async-processing-tasks';

export function resetClientAuthState(): void {
  try {
    const authStore = useAuthStore.getState();
    authStore.logout();
  } catch {
    // No-op: store may not be initialized in non-browser contexts
  }

  try {
    const taskStore = useTaskProcessingStore.getState();
    taskStore.clearAll();
  } catch {
    // No-op: store may not be initialized in non-browser contexts
  }

  if (typeof window !== 'undefined' && 'localStorage' in window) {
    try {
      window.localStorage.removeItem(TASK_PROCESSING_STORAGE_KEY);
    } catch {
      // Ignore storage removal errors (e.g., private mode)
    }
  }
}
